var map = {
	"./BjornAxe.json": [
		518,
		4
	],
	"./BjornCircle.json": [
		519,
		5
	],
	"./BjornE.json": [
		520,
		6
	],
	"./BjornN.json": [
		521,
		7
	],
	"./BjornNE.json": [
		522,
		8
	],
	"./BjornNW.json": [
		523,
		9
	],
	"./BjornS.json": [
		524,
		10
	],
	"./BjornSE.json": [
		525,
		11
	],
	"./BjornSW.json": [
		526,
		12
	],
	"./BjornW.json": [
		527,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1073;
module.exports = webpackAsyncContext;